import {
  CustomGetAppBanner,
  InpageBagButtonType,
  InpageBuyButtonType,
  InpageMembershipButtonType,
  InpageProfileButtonType,
} from "@brandclub/common-ui";

export enum CustomThemeKeys {
  ADD_TO_BAG_BUTTON = "addToBagButton",
  OUTLINED_BUTTON = "outlinedButton",
  SHARE_DIALOG_BUTTON = "shareDialogButton",
  CART_BUTTON = "cartButton",
  ADD_TO_BAG_MODAL_BUTTON = "addToBagModalButton",
  ADD_TO_BAG_BUBBLE = "addToBagBubble",
  DIALOG = "dialog",
  BAG_DRAWER_CHECKOUT_BUTTON = "bagDrawerCheckoutButton",
  BAG_DRAWER_VIEW_BAG_BUTTON = "bagDrawerViewBagButton",
}

export type CustomThemeType = {
  primary?: string;
  secondary?: string;
  tertiary?: string;
  enabled: boolean;
  capitalize?: boolean;
  borderEnabled?: boolean;
  globalButtonRadius?: number;
  backgroundColor?: string;
  textColor?: string;
  [key: string]: any;
};

export type StyleDataType = {
  primary: string;
  secondary: string;
  tertiary: string;
  globalButtonRadius: number;
  activeInpageCheckout?: boolean;
  dismissalPeriodDays?: number;
  getAppBanner?: {
    iosSmartBanner?: boolean;
    iosCustomBanner?: CustomGetAppBanner;
    androidCustomBanner?: CustomGetAppBanner;
  };

  customRewardPillColor?: {
    purchase?: string;
    survey?: string;
    content?: string;
    affiliate?: string;
    dailyDeal?: string;
    default?: string;
    purchaseText?: string;
    surveyText?: string;
    contentText?: string;
    affiliateText?: string;
    dailyDealText?: string;
    defaultText?: string;
    outOfStock?: string;
    outOfStockText?: string;
  };

  componentStyleOverrides: {
    [CustomThemeKeys.ADD_TO_BAG_BUTTON]: CustomThemeType;
    [CustomThemeKeys.OUTLINED_BUTTON]: CustomThemeType;
    [CustomThemeKeys.SHARE_DIALOG_BUTTON]: CustomThemeType;
    [CustomThemeKeys.CART_BUTTON]: CustomThemeType;
    [CustomThemeKeys.ADD_TO_BAG_MODAL_BUTTON]: CustomThemeType;
    [CustomThemeKeys.ADD_TO_BAG_BUBBLE]: CustomThemeType;
    [CustomThemeKeys.DIALOG]: CustomThemeType;
  };
  inpageCheckoutComponent: {
    bagButton: InpageBagButtonType;
    bagButtonMobile: InpageBagButtonType;
    membershipButton: InpageMembershipButtonType;
    membershipButtonMobile: InpageMembershipButtonType;
    profileButton: InpageProfileButtonType;
    profileButtonMobile: InpageProfileButtonType;
    buyButton: InpageBuyButtonType;
    buyButtonMobile: InpageBuyButtonType;
  };
  barFonts: {
    fontFamily: string;
    baseFontSize: number;
    fontFamilyLink: string;
    fontWeight: number;
  };
  [key: string]: any;
};
